exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bad-input{background:var(--accent-red100);border:1px solid var(--accent-red600)}.bad-input-error{font-size:12px;color:var(--accent-red500)}", ""]);

// exports
